Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cn = require('classnames');
var coreComponentsShared = require('../../../shared');
var consts = require('../../consts.js');
var Context = require('../../Context.js');
var ResponsiveContext = require('../../ResponsiveContext.js');
var layout_module = require('../../layout.module-c790465d.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var desktopStyles = {"footer":"modal__footer_1dy0u","sticky":"modal__sticky_1dy0u","fullscreen":"modal__fullscreen_1dy0u","size-500":"modal__size-500_1dy0u","size-600":"modal__size-600_1dy0u","size-800":"modal__size-800_1dy0u","size-1140":"modal__size-1140_1dy0u"};
require('./desktop.css');

var styles = {"footer":"modal__footer_rhk0y","sticky":"modal__sticky_rhk0y","highlighted":"modal__highlighted_rhk0y"};
require('./index.css');

var mobileStyles = {"footer":"modal__footer_n75mm","sticky":"modal__sticky_n75mm"};
require('./mobile.css');

var Footer = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, sticky = _a.sticky, _c = _a.layout, layout = _c === void 0 ? 'start' : _c, gap = _a.gap;
    var _d = React.useContext(Context.ModalContext), footerHighlighted = _d.footerHighlighted, setHasFooter = _d.setHasFooter;
    var _e = React.useContext(ResponsiveContext.ResponsiveContext), size = _e.size, view = _e.view, dataTestId = _e.dataTestId;
    React.useEffect(function () {
        setHasFooter(true);
    }, [setHasFooter]);
    return (React__default.default.createElement("div", { "data-test-id": coreComponentsShared.getDataTestId(dataTestId, 'footer'), className: cn__default.default(styles.footer, className, layout_module.layoutStyles[layout], gap && layout_module.layoutStyles["gap-".concat(gap)], (_b = {},
            _b[styles.highlighted] = sticky && footerHighlighted,
            _b[styles.sticky] = sticky,
            _b[desktopStyles.footer] = view === 'desktop',
            _b[desktopStyles.sticky] = view === 'desktop' && sticky,
            _b[desktopStyles[consts.SIZE_TO_CLASSNAME_MAP[size]]] = view === 'desktop',
            _b[mobileStyles.footer] = view === 'mobile',
            _b[mobileStyles.sticky] = view === 'mobile' && sticky,
            _b)) }, children));
};

exports.Footer = Footer;
